import React, { FC } from 'react';
import {
  Box,
  Heading,
  ListItem,
  OrderedList,
  Stack,
  VStack,
} from '@cardboard-ui/react';

interface FormThumbnailProps {
  name: string;
  questions: readonly { readonly id: string; readonly text: string }[];
}

const FormThumbnail: FC<FormThumbnailProps> = ({ name, questions }) => {
  const thumbnailQuestions =
    questions.length > 5 ? questions.slice(0, 5) : questions;
  return (
    <Box w="100%" h="100%">
      <VStack w="100%" h="100%" alignContent="center">
        <Stack
          p={3}
          bgColor="gray.50"
          _dark={{ bg: 'gray.600' }}
          h="100%"
          fontSize="70%"
          w="100%"
          overflow="hidden"
          paddingTop={7}
        >
          <Heading size="md">{name}</Heading>
          <OrderedList listStylePos="inside" spacing={2}>
            {thumbnailQuestions.map((question) => (
              <ListItem key={question.id}>{question.text}</ListItem>
            ))}
          </OrderedList>
        </Stack>
      </VStack>
    </Box>
  );
};

export default FormThumbnail;
